import script from "./etBtnMini.vue?vue&type=script&lang=js"
export * from "./etBtnMini.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__